import { useQuery } from '@tanstack/react-query';

import getUserList from 'Api/user/getUserList';

import getUserListRequest from './model/request/getUserListRequest';
import getUserListResponse from './model/response/getUserListResponse';

const useGetUserList = ({ queryParams }) => {
  return useQuery({
    queryKey: ['user-list', queryParams],
    queryFn: async () => {
      const queries = getUserListRequest(queryParams);

      const response = await getUserList(queries);

      return getUserListResponse(response);
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
  });
};

export default useGetUserList;
